import React from "react";
import { Svg } from "assets";

export const ChangePasswordAccorHeader = () => {
  return (
    <div className="change-password-accor-header">
      <Svg.Lock />
      <p className="change-password-accor-header-title">Change Password</p>
    </div>
  );
};
